<template lang="pug">
  Modal(:visible.sync="visible").orientacion
   
    prismic-rich-text(:field="titulo")
    prismic-rich-text(:field="presentacion")
    
    .espacio
    
    prismic-rich-text(:field="tituloN")
    section(v-for="(e,i) in nacionales" :key="i")
      prismic-rich-text(:field="e.titulo")
      a(:href="'tel:' + e.telefono").rosa Llama al {{ e.telefono }}
      prismic-rich-text(:field="e.descripcion")

    .espacio

    prismic-rich-text(:field="tituloL")
    section(v-for="e,i in locales")
      prismic-rich-text(:field="e['titulo-locales']")
      a(:href="'tel:' + e.telefono").rosa Llama al {{ e.telefono }}
      prismic-rich-text(:field="e.descripcion")

    .espacio
    
  
</template>
<script>
import Modal from "@/components/Modal" 
export default {
  name: 'Lineas de Orientacion',
  components: {
    Modal
  },
  props: ['visible'],
  model: {
    prop: 'visible'
  },
  data() {
    return {
      titulo: [],
      presentacion: [],
      locales: [],
      nacionales: [],
      tituloN: [],
      tituloL: []
    }
  },
  watch: {
    visible(){
      // Si el prop "Visible" es falso, entonces emita al parent visibel = falso
      !this.visible && this.$emit('update:visible', false)
    }
  },
  methods: {
    getContent () {
      this.$prismic.client.getSingle('orientacion').then((document) => {
      this.titulo = document.data.titulo
      this.presentacion = document.data.presentacion
      this.locales = document.data.locales
      this.nacionales = document.data.nacionales
      this.tituloN = document.data.titulo_nacionales
      this.tituloL = document.data.titulo_locales
      });
    }
  },
  created () {
    this.getContent();
  }

  
}
</script>
<style lang="sass">
.orientacion
  section
    font-size: .9em
    padding: 1.3em 0
    border-bottom: 1px solid lightgrey 

  h2 
    color: #4b2e83
    text-transform: uppercase
    font-size: 1em
    line-height: 2.6em
    border-bottom: 3px solid #4b2e83
  h3 
    font-size: 1em
  .rosa
    background: #f5f1fe
    color: #4b2e83
    border-radius: 4px
    padding: 12px
    position: relative
    display: block
    text-decoration: none
    &::after
      content: "📞"
      position: absolute
      right: 12px
  .espacio
    height: 2em  
</style>